var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavTargeting = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.046 2.198c.248.04.462.197.575.422l.586 1.173 1.172.586a.783.783 0 0 1 .204 1.255l-2.109 2.109a.783.783 0 0 1-.553.23h-1.785l-2.582 2.581a.783.783 0 1 1-1.108-1.108l2.582-2.582V5.08c0-.208.083-.407.23-.554l2.109-2.11a.783.783 0 0 1 .679-.218Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 3.754A6.246 6.246 0 1 0 16.246 10a.783.783 0 0 1 1.567 0A7.813 7.813 0 1 1 10 2.188a.783.783 0 1 1 0 1.566Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M10 7.269A2.731 2.731 0 1 0 12.731 10a.783.783 0 0 1 1.567 0A4.298 4.298 0 1 1 10 5.702a.783.783 0 1 1 0 1.567Z"
})));
SvgNavTargeting.displayName = "SvgNavTargeting";
export { SvgNavTargeting as ReactComponent };
export default SvgNavTargeting;